// IMPORTS:
var process = require("../shim/process.js");
var map = require("./map.js");
var globalConfig = require("../config.js");
var modes = require("./modes.js");
var spawnables = require("./spawnables.js");
var COLORS = require("./colors.js");
var UTILS = require("../libs/utils.js");
var prefabs = new (require("./prefabs.js"))(globalConfig);
var classes = require("./classes.js");
var version = require("../../version.json");
var A = 0;

// VALID CONFIG:
module.exports.validConfig = function (B) {
  if (B.modes) {
    for (var C = 0; C < B.modes.length; ++C) {
      if (!modes[B.modes[C]]) {
        return "Invalid Mode in Config.";
      }
    }
  }
  if (B.classes) {
    for (C = 0; C < B.classes.length; ++C) {
      if (!classes[B.classes[C]]) {
        return "Invalid Class in Config.";
      }
    }
  }
  if (B.settings) {
    var D = 0;
    for (var E in B.settings) {
      if (B.settings.hasOwnProperty(E)) {
        var F = B.settings[E];
        var G = -1;
        for (C = 0; C < globalConfig.serverConfig.length; ++C) {
          if (globalConfig.serverConfig[C].varN == E) {
            G = C;
            break;
          }
        }
        if (G < 0) {
          return "Invalid Setting in Config.";
        }
        var H = globalConfig.serverConfig[G];
        if (!H.input && !H.bool) {
          if (!UTILS.isNumber(F)) {
            return "Invalid Config Value.";
          }
          if (
            H.select ? H.options[F] == null : F > (H.maxF || H.max) || F < H.min
          ) {
            return "Config Value out of Range.";
          }
        }
        if (++D > globalConfig.serverConfig.length + 1) {
          return "Settings Mismatch.";
        }
      }
    }
  }
  return null;
};
module.exports.validWepConfig = function (B) {
  if (B) {
    for (var C in B) {
      for (var D in B[C]) {
        var E = B[C][D];
        var F = -1;
        for (var G = 0; G < globalConfig.weaponConfig.length; ++G) {
          if (globalConfig.weaponConfig[G].varN == D) {
            F = G;
            break;
          }
        }
        if (F < 0) {
          return "Invalid Setting in Config.";
        }
        var H = globalConfig.weaponConfig[F];
        if (!H.bool) {
          if (!UTILS.isNumber(E)) {
            return "Invalid Config Value.";
          }
          if (E > (H.maxF || H.max) || E < H.min) {
            return "Config Value out of Range.";
          }
        }
      }
    }
  }
  return null;
};

// VALIDATE MAP:
module.exports.validMap = function (mapData, C, D) {
  if (!D) {
    if (
      !UTILS.isString(mapData.name) ||
      !mapData.name.replace(/\s/g, "").length
    ) {
      return "Missing map name.";
    }
    if (mapData.name.indexOf("<") !== -1 || mapData.name.indexOf(">") !== -1) {
      return "Illegal characters in map name.";
    }
    if (mapData.name.length > 16) {
      return "Map name too long.";
    }
    if (!UTILS.isArray(mapData.spawns) || !mapData.spawns.length) {
      return "Missing spawn points.";
    }
    if (mapData.spawns.length > globalConfig.spawnLimit) {
      return "Too many spawn points.";
    }
    var E;
    for (var F = 0; F < mapData.spawns.length; ++F) {
      E = mapData.spawns[F];
      if (!UTILS.isArray(E) || !E.length || E.length < 3 || E.length > 6) {
        return "Spawn point error.";
      }
      for (var G = 0; G < E.length; ++G) {
        if (G < 3 && !UTILS.isNumber(E[G])) {
          return "Spawn point error.";
        }
        if (G == 3 && E[G] == null && E[G] == 1 && E[G] == 2) {
          return "Spawn team error.";
        }
      }
    }
    if (mapData.welMsg) {
      if (
        mapData.welMsg &&
        UTILS.isString(mapData.welMsg) &&
        mapData.welMsg != ""
      ) {
        if (mapData.welMsg.length > 70) {
          return "Welcome Message too Long";
        }
        if (
          /[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gim.test(mapData.welMsg)
        ) {
          return "Illegal characters in Welcome Message";
        }
      } else {
        mapData.welMsg = "";
      }
    }
  }
  if (!UTILS.isArray(mapData.objects) || !mapData.objects.length) {
    return "Missing objects.";
  }
  if (
    mapData.objects.length >
    (C ? globalConfig.objectLimitF : globalConfig.objectLimit)
  ) {
    return "Map exceeds overall object limit.";
  }
  var H;
  var I = 0;
  var J = 0;
  var K = {};
  var L = 0;
  var M = C ? globalConfig.objectColLimitF : globalConfig.objectColLimit;
  for (F = 0; F < mapData.objects.length; ++F) {
    H = mapData.objects[F];
    if (!prefabs.prefabs[H.i || 0]) {
      return "Invalid Object.";
    }
    if (!prefabs.prefabs[H.i || 0].noCol && H.l == null && H.col == null) {
      L++;
    }
    if (L > M) {
      return "Map exceeds collidable object limit.";
    }
    if (prefabs.prefabs[H.i || 0].name == "SIGN") {
      I++;
      if (H.st != null && typeof H.st != "string") {
        return "Object sign text error.";
      }
      if ((H.st || "").length > globalConfig.signTextLimit) {
        return "Object sign text to long.";
      }
      if (I > globalConfig.signLimit) {
        return "Too many signs.";
      }
      if (
        (H.sf && H.sf > globalConfig.signFontMax) ||
        (H.sf && H.sf < globalConfig.signFontMin)
      ) {
        return "Object sign font error.";
      }
    }
    if (prefabs.prefabs[H.i || 0].ai && ++J > globalConfig.aiLimit) {
      return "Too many AI.";
    }
    if (H.tct) {
      if (H.tct && UTILS.isString(H.tct) && H.tct != "") {
        if (H.tct.length > 70) {
          return "Trigger Message too Long";
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gim.test(H.tct)) {
          return "Illegal characters in Trigger Message";
        }
      } else {
        H.tct = "";
      }
    }
    if (
      parseInt(H.in) &&
      (K[parseInt(H.in)] ? K[parseInt(H.in)]++ : (K[parseInt(H.in)] = 1),
      K[parseInt(H.in)] > globalConfig.interfaceLimit)
    ) {
      return "Interface limit Exceeded: Max 20 (Per id)";
    }
    if (!UTILS.isArray(H.s) || H.s.length != 3 || !UTILS.arrayInts(H.s)) {
      return "Object scale error.";
    }
    if (!UTILS.isArray(H.p) || H.p.length != 3 || !UTILS.arrayInts(H.p)) {
      return "Object position error.";
    }
    if (UTILS.isArray(H.r)) {
      if (H.r.length != 3 || !UTILS.arrayInts(H.r)) {
        return "Object rotation value error.";
      }
    } else if (H.r != null) {
      return "Object rotation error.";
    }
    if (H.d != null && !UTILS.isNumber(H.d)) {
      return "Object direction error.";
    }
    H.col = !!H.col;
  }
  if (!D && mapData.game) {
    var N = 0;
    for (var O in mapData.game) {
      if (mapData.game.hasOwnProperty(O)) {
        var P = mapData.game[O];
        var Q = -1;
        for (F = 0; F < globalConfig.gameConfig.length; ++F) {
          if (globalConfig.gameConfig[F].varN == O) {
            Q = F;
            break;
          }
        }
        if (Q < 0) {
          return "Invalid Setting in Config.";
        }
        var R = globalConfig.gameConfig[Q];
        if (!R.input && !R.bool) {
          if (!UTILS.isNumber(P)) {
            return "Invalid Config Value.";
          }
          if (
            R.select
              ? R.options[P] == null
              : P > (R.maxF || R.maxP || R.maxG || R.max) || P < R.min
          ) {
            return "Config Value out of Range.";
          }
        }
        if (++N > globalConfig.gameConfig.length + 1) {
          return "Settings Mismatch.";
        }
      }
    }
  }
  return null;
};

// GAME:
module.exports.obj = function (
  isCustom,
  id,
  dbClient,
  RENDER,
  SOUND,
  PARTICLES,
  io,
  serverManager,
  serverPort,
  games,
) {
  this.isCustom = isCustom;
  this.isPrimary = id == 0;
  this.playTime = 0;
  this.playCount = 0;
  this.uniquePlays = [];
  this.updatedGameInstance = false;
  this.connectedClients = 0;
  this.bypassedUsers = 0;
  this.password = undefined;
  this.pendingGameId = null;
  this.sid = A++;
  this.gameInstance = null;
  this.initInProgress = false;
  this.isDestroyed = false;
  this.initQueue = [];
  this.gameClosed = false;
  this.map = new map.manager(RENDER, PARTICLES, UTILS, SOUND, globalConfig);
  this.store = require("./store.js");
  this.flags = require("./flags.js");
  this.weapons = require("./weapons.js");
  this.attach = require("./attach.js");
  this.reticles = require("./reticles.js");
  this.challenges = require("./challenges.js");
  this.classes = classes;
  this.streaks = require("./streaks.js");
  this.maxStreak = this.streaks.sort((a0, a1) =>
    a0.kills < a1.kills ? 1 : a1.kills < a0.kills ? -1 : 0,
  )[0].kills;
  this.triggers = require("./triggers.js");
  this.sprays = require("./sprays.js");
  this.AI = new (require("./ai.js"))(
    this,
    RENDER,
    SOUND,
    UTILS,
    io,
    globalConfig,
  );
  this.projectiles = new (require("./projectile.js"))(this, io);
  this.controls = null;
  this.players = new (require("./players.js").manager)(
    this,
    RENDER,
    SOUND,
    PARTICLES,
    UTILS,
    COLORS,
    prefabs,
    globalConfig,
    io,
  );
  this.endData = {
    ed: [],
    vo: null,
    mts: [],
  };
  this.billboard = {};
  this.endTimer = 0;
  this.endIndex = null;
  this.hideWeapon = [false, false, false];
  this.banList = [];
  this.voteToKick = null;
  this.voteInitiators = [];
  this.teamFlags = [];
  this.teamScoreUpd = [];
  var player;
  var Q;
  var U;
  var V = this;
  var W = null;
  this.passCode = null;
  this.uniquePlay = function (a0) {
    if (a0 && !a0.countedPlay) {
      if (this.uniquePlays.indexOf(a0.id) < 0) {
        this.uniquePlays.push(a0.id);
        this.playCount++;
        a0.countedPlay = true;
      } else {
        a0.countedPlay = true;
      }
    }
  };
  // GET INFO:
  this.getInfo = function () {
    return this.mode.alias + "_" + this.map.maps[this.mapIndex].name;
  };
  this.applyConfig = function (config, a1, a2) {
    config = config || {};
    if (a2) {
      a1 = 1;
    }
    this.config = {
      cost: 0,
    };
    if (config.weps) {
      this.weaponConfig = this.weapons.map((a9) => ({
        ...a9,
      }));
      this.customWeaponData = config.weps;
      for (var a3 = 0; a3 < globalConfig.weaponConfig.length; ++a3) {
        a6 = globalConfig.weaponConfig[a3];
        for (var a4 = 0; a4 < this.weaponConfig.length; a4++) {
          if (
            config.weps[a4] &&
            this.weapons[a4][a6.varN] != null &&
            config.weps[a4][a6.varN] != null
          ) {
            if (a6.bool) {
              this.weaponConfig[a4][a6.varN] = !!config.weps[a4][a6.varN];
            } else {
              var a5 = config.weps[a4][a6.varN];
              if (!UTILS.isNumber(a5)) {
                continue;
              }
              if (a5 != this.weaponConfig[a4][a6.varN]) {
                this.weaponConfig[a4][a6.varN] = UTILS.limitMM(
                  a5,
                  a6.min,
                  a6.max,
                );
              }
            }
          }
        }
      }
    } else {
      this.weaponConfig = this.weapons;
    }
    var a6;
    for (a3 = 0; a3 < globalConfig.serverConfig.length; ++a3) {
      if ((a6 = globalConfig.serverConfig[a3]).bool) {
        this.config[a6.varN] =
          config[a6.varN] == null ? a6.def : !!config[a6.varN];
        if (a6.cost && this.config[a6.varN]) {
          this.config.cost += a6.cost;
        }
      } else if (a6.input) {
        a5 = config[a6.varN];
        if (!UTILS.isString(a5)) {
          a5 = a6.def;
        }
        this.config[a6.varN] = UTILS.sanitizeStr(a5);
        if (a5.length > 16) {
          a5 = a5.substring(0, 16);
        }
      } else if (a6.select) {
        a5 = config[a6.varN];
        this.config[a6.varN] = a6.options[a5] == null ? a6.def : parseInt(a5);
      } else {
        a5 = config[a6.varN];
        if (!UTILS.isNumber(a5)) {
          a5 = a6.def;
        }
        var a7 = a6.max;
        if (a1 == 3) {
          a7 = a6.maxF || a7;
        } else if (a1 == 2) {
          a7 = a6.maxP || a7;
        } else if (a1 == 0) {
          a7 = a6.maxG || a7;
        }
        this.config[a6.varN] = UTILS.limitMM(a5, a6.min, a7);
      }
    }
    this.config.maps = config.maps;
    if (
      !UTILS.isArray(this.config.maps) ||
      !this.config.maps.length ||
      this.config.maps.length > this.map.maps.length
    ) {
      this.config.maps = [];
      for (a3 = 0; a3 < this.map.maps.length; a3++) {
        this.config.maps.push(a3);
      }
    } else {
      for (a3 = 0; a3 < this.config.maps.length; a3++) {
        if (!this.map.maps[this.config.maps[a3]]) {
          this.config.maps = [0];
          break;
        }
      }
    }
    this.config.modes = config.modes;
    if (
      !UTILS.isArray(this.config.modes) ||
      !this.config.modes.length ||
      this.config.modes.length > this.map.modes.length
    ) {
      this.config.modes = null;
    } else {
      for (a3 = 0; a3 < this.config.modes.length; a3++) {
        if (!this.map.modes[this.config.modes[a3]]) {
          this.config.modes = null;
          break;
        }
      }
    }
    var a8 = false;
    this.config.classes = config.classes;
    if (
      !UTILS.isArray(this.config.classes) ||
      !this.config.classes.length ||
      this.config.classes.length > this.classes.length
    ) {
      a8 = true;
    } else {
      for (a3 = 0; a3 < this.config.classes.length; a3++) {
        if (!this.classes[this.config.classes[a3]]) {
          a8 = true;
          break;
        }
      }
    }
    if (a8) {
      this.config.classes = [];
      for (a3 = 0; a3 < this.classes.length; a3++) {
        if (!this.classes[a3].hide || this.isCustom) {
          this.config.classes.push(a3);
        }
      }
    }
    this.config.isFromQueue = config.isFromQueue || a2;
  };
  this.applyConfig();
  this.updateBillboards = function (a0) {
    a0 = a0 || {};
    this.billboard.txt = a0.txt || "Your Ad Here";
    this.billboard.txtCol = a0.txtCol || "#e3e3e3";
    this.billboard.bgCol = a0.bgCol || "#000000";
    this.map.billboard = this.billboard;
  };
  // REPLACE MAP:
  this.customMap = function (data, id, creator, a3, a4, a5) {
    if (data) {
      try {
        console.info("[game.customMap] received payload", {
          id: id,
          creator: creator,
          dataType: typeof data,
          dataLength: data.length,
          bypassValidation: !!a5,
        });
        if (
          (data = data.replace(/\(/gm, "ï¼").replace(/\)/gm, "ï¼")).indexOf(
            "(",
          ) != -1
        ) {
          console.warn(
            "[game.customMap] invalid map format: contains raw parentheses",
          );
          return "Invalid Map Format.";
        }
        var a6 = JSON.parse(UTILS.decompressKeys(data));
        console.info("[game.customMap] parsed map object", {
          name: a6 && a6.name,
          objectCount: a6 && a6.objects ? a6.objects.length : 0,
          spawnCount: a6 && a6.spawns ? a6.spawns.length : 0,
        });
        var accType = UTILS.getAccountType(a4);
        var a8 = {};
        if (a3) {
          try {
            a8 = JSON.parse(a3);
          } catch (ab) {}
        }
        if (io) {
          this.customMapData = {
            data: data,
            id: id,
            accType: accType,
            creator: creator,
            thumb: !!a8.t,
          };
        }
        if (!a5) {
          var a9 = module.exports.validMap(a6, accType > 1);
          if (a9) {
            console.warn("[game.customMap] validation failed", a9);
            return a9;
          }
        }
        for (var aa = 0; aa < a6.objects.length; ++aa) {
          var prefab =
            prefabs.prefabs[a6.objects[aa].i || a6.objects[aa].id || 0];
          if (!prefab) {
            console.warn(
              "[game.customMap] object id lookup failed, falling back to prefab 0",
              {
                index: aa,
                object: a6.objects[aa],
              },
            );
            prefab = prefabs.prefabs[0];
          }
          a6.objects[aa].i = prefab ? prefab.name : "UNKNOWN";
          var texturePrefab = prefabs.textures[a6.objects[aa].t || 0];
          if (!texturePrefab) {
            console.warn(
              "[game.customMap] texture lookup failed, falling back to texture 0",
              {
                index: aa,
                object: a6.objects[aa],
              },
            );
            texturePrefab = prefabs.textures[0];
          }
          a6.objects[aa].t = texturePrefab ? texturePrefab.name : "DEFAULT";
        }
        a6.creator = creator;
        this.map.setMaps([a6]);
        this.config.maps = [0];
        console.info("[game.customMap] map applied successfully", {
          name: a6.name,
          mapCount: this.map.maps.length,
        });
      } catch (ac) {
        console.error("[game.customMap] map error", ac);
        return "Map error occured.";
      }
    }
  };
  // SOUND FROM PLAYER:
  this.playerSound = function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
    a0 = UTILS.isNumber(a0) && !a9 ? globalConfig.networkSounds[a0] : a0;
    var aa = !!a8 || this.players.findBySid(a1);
    var ab = Howler.pos();
    if (
      aa &&
      (!a7 ||
        !(
          a7 <
          (aa.latestData
            ? UTILS.getD3D(aa.x, aa.y, aa.z, ab[0], ab[1], ab[2])
            : UTILS.getD3D(a2, a3, a4, ab[0], ab[1], ab[2]))
        ))
    ) {
      if (aa.latestData) {
        SOUND.play3D(a0, aa.x, aa.y, aa.z, a5 || 1, a6, null, null, a9);
      } else {
        SOUND.play3D(a0, a2, a3, a4, a5 || 1, a6, null, null, a9);
      }
    }
  };
  this.triggerImgSound = function (a0, a1, a2) {
    if (io) {
      io.send(a2.id, "is", a0, a1);
    } else {
      if (a0) {
        SOUND.play(a0, 1);
      }
      if (a1 && imgFlash) {
        imgFlash.style.display = "block";
        imgFlash.style.opacity = 1;
        imgFlash.style.backgroundImage =
          "url('https://assets.krunker.io/textures/" + a1 + ".png')";
      }
    }
  };
  // PLAY SOUND:
  this.playSound = function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, aa) {
    if (a1) {
      if (SOUND) {
        SOUND.play(
          UTILS.isNumber(a0) && !aa ? globalConfig.networkSounds[a0] : a0,
          a1,
          a8,
          a7,
        );
      } else {
        for (var ab = 0; ab < this.players.list.length; ++ab) {
          if (
            ((player = this.players.list[ab]).active || player.spectating) &&
            (a2 != player.sid || a6)
          ) {
            io.send(
              player.id,
              "s",
              a0,
              a2,
              Math.round(a3),
              Math.round(a4),
              Math.round(a5),
              a1,
              a7,
              a9,
              aa,
            );
          }
        }
      }
    }
  };
  // MOVE OBJECT AND MESH:
  this.moveObj = function (a0, a1, a2, a3) {
    a0.x = a1;
    a0.y = a2;
    a0.z = a3;
    if (a0.meshRef) {
      a0.meshRef.position.set(a1, a2, a3);
    }
  };
  // EXPLOSION:
  this.explosion = function (a0, a1, a2, a3, a4, a5, a6) {
    for (var a7 = 0; a7 < this.players.list.length; ++a7) {
      if (
        ((player = this.players.list[a7]).active || player.spectating) &&
        (io.send(
          player.id,
          "ex",
          Math.round(a0),
          Math.round(a1),
          Math.round(a2),
          Math.round(a3),
        ),
        player.active)
      ) {
        if (
          (a9 =
            1 -
            (a8 = UTILS.getD3D(a0, a1, a2, player.x, player.y, player.z)) /
              a3) > 0 &&
          this.players.changeHealth(
            player,
            a5,
            a5.smite ? 10000 : a4 * a9 * (player == a5 ? 0.2 : 1),
            a5 == player,
          )
        ) {
          this.players.kill(player, a5, {
            dst: a8,
            weaponId: a6.weaponId,
            weapon: a6.weapon,
          });
        }
      }
    }
    for (a7 = 0; a7 < this.AI.ais.length; ++a7) {
      if ((player = this.AI.ais[a7]).active) {
        var a8;
        var a9;
        if (
          (a9 =
            1 -
            (a8 = UTILS.getD3D(a0, a1, a2, player.x, player.y, player.z)) /
              a3) > 0 &&
          a5
        ) {
          player.changeHealth(-a4 * a9, a5);
          if (!player.active && player.killScore) {
            this.players.score(a5, player.killScore, true);
          }
          io.send(
            a5.id,
            "4",
            player.sid,
            Math.round(a4 * a9),
            0,
            !player.active,
            1,
          );
        }
      }
    }
  };
  var X = [];
  // GET SPAWN POINT:
  this.getSpawnPoint = function (
    team,
    excludedPlayer,
    useFirstSpawn,
    forceCompSpawn,
  ) {
    var useCompSpawns =
      (!!this.waitTimers &&
        !!this.waitTimers[0] &&
        !!this.waitTimers[0].comp) ||
      !!forceCompSpawn;
    if (useFirstSpawn) {
      return this.map.spawns[0];
    }
    X.length = 0;
    var bestSpawnDst;
    for (
      var spawnIndex = 0;
      spawnIndex < this.map.spawns.length;
      ++spawnIndex
    ) {
      this.map.spawns[spawnIndex].dst = 0;
      for (var a7 = 0; a7 < this.players.list.length; ++a7) {
        if (
          (player = this.players.list[a7]) &&
          player.active &&
          player != excludedPlayer &&
          (!team || player.team != team) &&
          !this.canSee(
            player,
            this.map.spawns[spawnIndex].x,
            this.map.spawns[spawnIndex].y + globalConfig.playerHeight,
            this.map.spawns[spawnIndex].z,
          )
        ) {
          this.map.spawns[spawnIndex].dst++;
        }
      }
    }
    this.map.spawns.sort(UTILS.orderByDst);
    bestSpawnDst = this.map.spawns[0].dst;
    for (spawnIndex = 0; spawnIndex < this.map.spawns.length; ++spawnIndex) {
      if (!this.map.spawns[spawnIndex].comp || useCompSpawns) {
        if (useCompSpawns && this.mode && this.mode.teams) {
          if (
            this.map.spawns[spawnIndex].comp &&
            this.map.spawns[spawnIndex].team == team
          ) {
            X.push(this.map.spawns[spawnIndex]);
            break;
          }
        } else if (this.map.spawns[spawnIndex].dst == bestSpawnDst) {
          this.map.spawns[spawnIndex].dst = 0;
          for (a7 = 0; a7 < this.players.list.length; ++a7) {
            if (
              (player = this.players.list[a7]).active &&
              player != excludedPlayer &&
              (!team || player.team != team)
            ) {
              this.map.spawns[spawnIndex].dst += UTILS.getD3D(
                this.map.spawns[spawnIndex].x,
                this.map.spawns[spawnIndex].y,
                this.map.spawns[spawnIndex].z,
                player.x,
                player.y,
                player.z,
              );
            }
          }
          if (this.mode && this.mode.flags) {
            for (var a8 = 0; a8 < this.map.manager.flags.length; ++a8) {
              if ((player = this.map.manager.flags[a8]).team != team) {
                this.map.spawns[spawnIndex].dst += UTILS.getD3D(
                  this.map.spawns[spawnIndex].x,
                  this.map.spawns[spawnIndex].y,
                  this.map.spawns[spawnIndex].z,
                  player.x,
                  player.y,
                  player.z,
                );
              }
            }
          }
          if (
            (team && this.map.spawns[spawnIndex].team == team) ||
            !this.map.spawns[spawnIndex].team
          ) {
            X.push(this.map.spawns[spawnIndex]);
          }
        }
      }
    }
    X.sort(UTILS.orderByDst);
    X.reverse();
    var a9 = X[0] || this.map.spawns[0];
    if (useCompSpawns) {
      return this.getPointSpread(a9.x, a9.z, a9.y, 40, a9.dir);
    } else {
      return a9;
    }
  };
  this.getPointSpread = function (a0, a1, a2, a3, a4) {
    var a5 = UTILS.randFloat(-Math.PI, Math.PI);
    var a6 = 1 / (a3 * Math.sin(a5 + Math.PI));
    var a7 = 1 / (a3 * Math.cos(a5 + Math.PI));
    var a8 = 1;
    for (var a9 = 0; a9 < this.map.manager.objects.length; ++a9) {
      if ((Q = this.map.manager.objects[a9]).active) {
        var aa = UTILS.lineInRect(
          a0,
          a1,
          a2 + 1,
          a6,
          a7,
          1,
          Q.x - Q.width,
          Q.z - Q.length,
          Q.y - Q.height,
          Q.x + Q.width,
          Q.z + Q.length,
          Q.y + Q.height,
        );
        if (aa && aa <= a8) {
          a8 = aa;
        }
      }
    }
    return {
      dir: a4,
      x: a0 + (a3 -= 10) * a8 * Math.sin(a5 + Math.PI),
      z: a1 + a3 * a8 * Math.cos(a5 + Math.PI),
      y: a2,
    };
  };
  // UPDATE ACCOUNTS:
  this.updateAccounts = function () {
    var a0 = [];
    for (var a1 = 0; a1 < this.players.list.length; ++a1) {
      if ((player = this.players.list[a1]).account && !player.account.hack) {
        player.account.timePlayed += player.playTime || 0;
        this.players.saveClassScores(player);
        this.checkChallenges(player);
        this.transferStats(player);
        if (this.host == null && (!this.mode || !this.mode.noReward)) {
          player.account.games++;
          player.account.kills += player.kills;
          player.account.deaths += player.deaths;
          player.account.score += player.score;
          player.account.clanKills += UTILS.limitMM(player.clanKillsP, 0, 60);
          if (player.didWin) {
            player.account.wins++;
          }
          a0.push(player);
        }
        io.send(player.id, "ua", player.account.getData());
      }
    }
    if (a0.length) {
      this.saveRewards(a0);
    }
  };
  this.updateELO = function () {
    var a0 = true;
    for (var a1 of this.players.list) {
      if (a1.account && a1.didWin) {
        a0 = false;
        break;
      }
    }
    var a2 = {};
    for (var a1 of this.players.list) {
      if (
        !a1.kpdData &&
        !!a1.account &&
        !a1.account.hack &&
        !(a1.account.level < globalConfig.minRankedLevel)
      ) {
        if (!a2[(a3 = a1.team || a1.id)]) {
          a2[a3] = {
            eloAvg: 0,
            playerCount: 0,
          };
        }
        a2[a3].eloAvg += a1.account[this.queueConfig.accountKey];
        a2[a3].playerCount += 1;
      }
    }
    for (var a3 in a2) {
      a2[a3].eloAvg /= a2[a3].playerCount;
    }
    var a4 = globalConfig.eloK;
    for (var a1 of this.players.list) {
      if (
        !a1.kpdData &&
        !!a1.account &&
        !a1.account.hack &&
        !(a1.account.level < globalConfig.minRankedLevel)
      ) {
        a3 = a1.team || a1.id;
        var a5 = null;
        for (var a6 in a2) {
          if (a6 != a3) {
            a5 = a2[a6].eloAvg;
          }
        }
        if (a5 == null) {
          a5 = a2[a3].eloAvg;
        }
        var a7 =
          1 /
          (1 +
            Math.pow(10, (a5 - a1.account[this.queueConfig.accountKey]) / 330));
        var a8 = a1.didWin ? 1 : 0;
        a1.ELO = a0 ? 0 : a4 * (a8 - a7);
        a1.account[this.queueConfig.accountKey] += a1.ELO || 0;
        if (a1.account[this.queueConfig.accountKey] < 0) {
          a1.account[this.queueConfig.accountKey] = 0;
        }
        dbClient.call(
          54,
          [
            a1.account.id,
            a1.account[this.queueConfig.accountKey],
            this.queueConfig.teams[0].size,
          ],
          function () {},
        );
      }
    }
  };
  // SAVE REWARDS:
  this.saveRewards = function (a0) {
    var a1 = "";
    for (var a2 = 0; a2 < a0.length; ++a2) {
      if (a0[a2] && a0[a2].account && a0[a2].reward) {
        a1 += (a1.length ? "," : "") + a0[a2].account.id + "," + a0[a2].reward;
      }
    }
    if (a1.length) {
      dbClient.call(20, [a1], function (a3, a4) {
        if (a4 && a4[0] && a4[0][0] && (a4 = a4[0][0].result)) {
          try {
            a4 = a4.split(",");
            var a5;
            for (var a6 = 0; a6 < a4.length; ++a6) {
              if ((a5 = parseInt(a4[a6])) && a0[a6]) {
                a0[a6].account.funds = a5;
                io.send(a0[a6].id, "uf", a5);
              }
            }
          } catch (a7) {}
        }
      });
    }
  };
  // INCREASE PLAYER STAT:
  this.incStat = function (a0, a1) {
    if (a1 && a1.account && this.host == null) {
      if (!a1.tmpStats[a0]) {
        a1.tmpStats[a0] = 0;
      }
      a1.tmpStats[a0]++;
    }
  };
  this.transferStats = function (a0) {
    if (a0 && a0.account && this.host == null) {
      for (var a1 in a0.tmpStats) {
        a0.account.stats[a1] ||= 0;
        a0.account.stats[a1] += a0.tmpStats[a1];
      }
      a0.tmpStats = {};
    }
  };
  this.checkLeave = function (a0) {
    if (a0) {
      if (a0.account && this.mode && this.mode.isRanked && !this.endTimer) {
        a0.account.stats.abR = Date.now();
        a0.account[this.queueConfig.accountKey] -= globalConfig.rankedDeduction;
        if (a0.account[this.queueConfig.accountKey] < 0) {
          a0.account[this.queueConfig.accountKey] = 0;
        }
        dbClient.call(
          54,
          [
            a0.account.id,
            a0.account[this.queueConfig.accountKey],
            this.queueConfig.teams[0].size,
          ],
          function () {},
        );
      }
    }
  };
  this.checkChallenges = function (a0) {
    if (
      a0 &&
      a0.account &&
      this.host == null &&
      a0.account.level >= globalConfig.minChalLevel &&
      a0.account.stats.chgP
    ) {
      if (a0.account.chal >= globalConfig.maxChal) {
        return;
      }
      var a1;
      var a2 = UTILS.getChalProg(a0.account, this).split(",").map(Number);
      for (
        var a3 = this.challenges[a0.account.chal], a4 = 0, a5 = 0;
        a5 < a3.list.length;
        a5++
      ) {
        if ((a1 = a3.list[a5].chck(this, a0, parseInt(a2[a5]) || 0)) == -1) {
          a4++;
        } else if (a1 == -2) {
          a4++;
          io.send(a0.id, "chgC", a5);
          a2[a5] = a3.list[a5].val;
        } else {
          a2[a5] = a1 == -3 ? 0 : a1;
        }
      }
      if (a4 >= a3.list.length) {
        dbClient.call(
          56,
          [a0.account.id, a0.account.chal + 1, a3.reward.funds],
          function (a6, a7) {
            if (!a6) {
              if (
                !(a6 = (a7 = a7 && a7[0] ? a7[0][0] : null)
                  ? a7.error_text
                  : "Error occured.")
              ) {
                window.IO.broadcast(
                  "game" + V.sid,
                  "ch",
                  null,
                  (a0.fakeName || a0.alias) +
                    " completed Challenge Level " +
                    a7.chal,
                  2,
                );
                if (a0.account) {
                  a0.account.chal = a7.chal;
                  a2 =
                    a0.account.chal >= globalConfig.maxChal
                      ? []
                      : Array(V.challenges[a0.account.chal].list.length).fill(
                          0,
                        );
                  a0.account.stats.chgP = a0.account.chal + ":" + a2.join();
                  V.sendChallUpdate(a0);
                }
              }
            }
          },
        );
      } else {
        a0.account.stats.chgP = a0.account.chal + ":" + a2.join();
        this.sendChallUpdate(a0);
      }
    }
  };
  this.sendChallUpdate = function (a0) {
    if (a0 && a0.account) {
      io.send(a0.id, "chg", a0.account.chal, a0.account.stats.chgP);
    }
  };
  // SAVE PLAYER DATA:
  this.savePlayerData = function (a0, a1) {
    if (dbClient && a0.account) {
      if (this.host == null) {
        var a2 = 0;
        var a3 = 0;
        var a4 = 0;
        for (var a5 in globalConfig.regionIND) {
          if (a5 == a1) {
            a2 = globalConfig.regionIND[a5];
            break;
          }
        }
        if (a2) {
          for (var a6 = 1; a6 < 5; ++a6) {
            if (a2 == a6) {
              if (!a0.account.stats["r" + a6]) {
                a0.account.stats["r" + a6] = 0;
              }
              a0.account.stats["r" + a6]++;
            }
            if (
              a0.account.stats["r" + a6] &&
              a0.account.stats["r" + a6] >= a4
            ) {
              a4 = a0.account.stats["r" + a6];
              a3 = a6;
            }
          }
        }
        if (a3) {
          a0.account.regionInd = a3;
        }
      }
      var a7 = this.customMapData ? this.customMapData.id : 0;
      var a8 = a0.account;
      if (a8) {
        dbClient.call(2, [
          a8.id,
          a8.kills,
          a8.wins,
          a8.games,
          a8.deaths,
          a8.score,
          a8.clan,
          a8.timePlayed,
          JSON.stringify(a8.stats),
          a8.regionInd,
          a7,
          a8.clanKills,
          a8.clanDeaths,
        ]);
      }
    }
  };
  // LOCK PLAYER:
  this.lockPlayer = function (a0, a1) {
    a0.locked = a1;
    io.send(a0.id, "lock", a1);
  };
  this.lockMove = function (a0, a1, a2, a3, a4) {
    V.moveLock = true;
    if (io) {
      var a5;
      for (var a6 = 0; a6 < this.players.list.length; a6++) {
        if (!(a5 = this.players.list[a6]).spectating && a5.active) {
          io.send(a5.id, "lm", a5.x, a5.y, a5.z, a5.yaw);
        }
      }
    } else if (a0) {
      a0.resetPosition(a1, a2, a3, a4);
    }
  };
  this.unlockMove = function () {
    V.moveLock = false;
    if (io) {
      window.IO.broadcast("game" + V.sid, "ulm");
    }
  };
  this.warmupReset = function () {
    var a0;
    for (var a1 = 0; a1 < this.players.list.length; a1++) {
      if (!(a0 = this.players.list[a1]).spectating && a0.active) {
        var a2 = this.getSpawnPoint(a0.team, a0, false, true);
        a0.resetPosition(
          a2.x,
          a2.y,
          a2.z,
          (-((a2.dir || 0) + 1) * Math.PI) / 2,
        );
      }
    }
  };
  // UPDATE TEAM:
  this.updateTeam = function (a0, a1) {
    a0.team = a1;
    for (var a2 = 0; a2 < a0.sentTo.length; ++a2) {
      io.send(a0.sentTo[a2], "tm", a0.sid, a1);
    }
    this.players.syncLeaders(true);
  };
  this.plantBomb = function (a0) {
    if (io) {
      io.send(a0.id, "am", ["Bomb Planted", 200]);
      this.players.score(a0, 200);
      var a1 = this.players.dropWeapon(a0, false, 17, false) || {};
      this.activeBomb = {
        team: a0.team,
        tick: 2000,
        time: 40000,
        x: a1.x,
        y: a1.y,
        z: a1.z,
      };
      window.IO.broadcast("game" + this.sid, "gmsg", "BOMB PLANTED");
      window.IO.broadcast("game" + this.sid, "so", "bo_plant", 1, 1);
    }
  };
  this.diffuseBomb = function (a0) {
    if (io && this.activeBomb && a0) {
      this.activeBomb = null;
      a0.diffuses++;
      window.IO.broadcast("game" + this.sid, "so", "bo_diff", 1, 1);
    }
  };
  this.updateBomb = function (a0) {
    if (this.activeBomb && !this.endTimer) {
      this.activeBomb.tick -= a0;
      this.activeBomb.time -= a0;
      if (this.activeBomb.time <= 0) {
        window.IO.broadcast("game" + this.sid, "n", 1);
        for (var a1 = 0; a1 < this.players.list.length; ++a1) {
          if (
            (player = this.players.list[a1]).active &&
            this.activeBomb.team != player.team
          ) {
            this.players.kill(player, null, null, false, true);
          }
        }
        this.activeBomb = null;
      } else if (this.activeBomb.tick <= 0) {
        var a2 = 2000;
        if (this.activeBomb.time <= 2000) {
          a2 = 150;
        } else if (this.activeBomb.time <= 5000) {
          a2 = 200;
        } else if (this.activeBomb.time <= 10000) {
          a2 = 500;
        } else if (this.activeBomb.time <= 20000) {
          a2 = 1000;
        }
        this.activeBomb.tick = a2;
        window.IO.broadcast(
          "game" + this.sid,
          "so",
          "beep_0",
          1,
          0,
          this.activeBomb.x || 0,
          this.activeBomb.y || 0,
          this.activeBomb.z || 0,
        );
      }
    }
  };
  // START NUKE:
  this.startNuke = function (a0) {
    this.nukeTimer = 10000;
    this.nukePlayer = a0;
    window.IO.broadcast("game" + this.sid, "n", 0);
  };
  this.doVirus = function (a0, a1) {
    var a2 = a1.meleeIndex;
    if (a0 && a0.account && a1 && a1.account) {
      if (
        !a0.account.virus &&
        a2 != 1659 &&
        a1.account.virus &&
        a0.hatIndex != 944
      ) {
        a0.account.virus = 1;
        window.IO.broadcast(
          "game" + this.sid,
          "ch",
          null,
          (a0.fakeName || a0.alias) + " has contracted Krunkitis",
          2,
          "#76ff03",
        );
        dbClient.call(64, [a0.account.id], function () {});
      } else if (a0.account.virus && a2 == 1659) {
        a0.account.virus = 0;
        window.IO.broadcast(
          "game" + this.sid,
          "ch",
          null,
          (a0.fakeName || a0.alias) + " has been Cured",
          2,
          "#76ff03",
        );
        dbClient.call(69, [a0.account.id, 0], function () {});
      }
    }
  };
  var Y = [];
  // INFECT RANDOM:
  this.infectRandom = function () {
    Y.length = 0;
    for (var a0 = 0; a0 < this.players.list.length; ++a0) {
      if (this.players.list[a0].active) {
        Y.push(a0);
      }
    }
    var a1 = 1;
    if (Y.length >= 14) {
      a1 = 3;
    } else if (Y.length >= 8) {
      a1 = 2;
    }
    var a2;
    for (a0 = 0; a0 < a1; ++a0) {
      a2 = UTILS.randInt(0, Y.length - 1);
      if ((player = this.players.list[Y[a2]])) {
        this.updateTeam(player, 2);
        this.players.kill(player, null, null, true);
        window.IO.broadcast(
          "game" + this.sid,
          "ac",
          player.sid,
          null,
          "got infected",
        );
      }
      Y.splice(a2, 1);
    }
  };
  // SIMON SAYS:
  this.pickSimon = function () {
    Y.length = 0;
    var a0 = null;
    for (var a1 = 0; a1 < this.players.list.length; ++a1) {
      if (this.players.list[a1].active) {
        if (this.host == this.players.list[a1].id) {
          a0 = this.players.list[a1];
          break;
        }
        Y.push(a1);
      }
    }
    a0 ||= this.players.list[Y[UTILS.randInt(0, Y.length - 1)]];
    if (a0) {
      this.updateTeam(a0, 2);
      a0.maxHealth = 5000;
      a0.health = a0.maxHealth;
      io.send(a0.id, "h", a0.health);
    }
  };
  this.pickTraitors = function () {
    Y.length = 0;
    for (var a0 = 0; a0 < this.players.list.length; ++a0) {
      if (this.players.list[a0].active) {
        Y.push(a0);
      }
    }
    var a1 = 1;
    if (Y.length >= 12) {
      a1 = 3;
    } else if (Y.length >= 6) {
      a1 = 2;
    }
    var a2;
    for (a0 = 0; a0 < a1; ++a0) {
      a2 = UTILS.randInt(0, Y.length - 1);
      if ((player = this.players.list[Y[a2]])) {
        this.updateTeam(player, 2);
      }
      Y.splice(a2, 1);
    }
  };
  this.pickStalker = function () {
    Y.length = 0;
    for (var a0 = 0; a0 < this.players.list.length; ++a0) {
      if (this.players.list[a0].active) {
        Y.push(a0);
      }
    }
    if ((player = this.players.list[Y[UTILS.randInt(0, Y.length - 1)]])) {
      this.updateTeam(player, 2);
      player.maxHealth = 400;
      player.health = player.maxHealth;
      player.regen = 0;
      io.send(player.id, "h", player.health);
      player.updateLoadout(this, 0, true, 12);
      window.IO.broadcast(
        "game" + this.sid,
        "inat",
        player.sid,
        [12],
        0,
        undefined,
        undefined,
        false,
      );
    }
  };
  // BOSS MODE:
  this.pickBoss = function () {
    Y.length = 0;
    for (var a0 = 0; a0 < this.players.list.length; ++a0) {
      if (this.players.list[a0].active) {
        Y.push(a0);
      }
    }
    if ((player = this.players.list[Y[UTILS.randInt(0, Y.length - 1)]])) {
      this.updateTeam(player, 2);
      player.maxHealth = 10000;
      player.health = player.maxHealth;
      player.regen = 0;
      io.send(player.id, "h", player.health);
    }
  };
  this.lockSeekers = function () {
    for (var a0 = 0; a0 < this.players.list.length; ++a0) {
      if (this.players.list[a0].active && this.players.list[a0].team == 2) {
        this.lockPlayer(this.players.list[a0], true);
      }
    }
  };
  this.pickSeeker = function () {
    Y.length = 0;
    for (var a0 = 0; a0 < this.players.list.length; ++a0) {
      if (this.players.list[a0].active) {
        Y.push(a0);
      }
    }
    if ((player = this.players.list[Y[UTILS.randInt(0, Y.length - 1)]])) {
      this.updateTeam(player, 2);
      this.lockPlayer(player, true);
    }
  };
  this.releaseSeeker = function () {
    for (var a0 = 0; a0 < this.players.list.length; ++a0) {
      if ((player = this.players.list[a0]).team == 2) {
        this.lockPlayer(player, false);
      }
    }
  };
  // DESTROY OBJECT:
  this.destroyObj = function (a0) {
    for (var a1 = 0; a1 < V.map.manager.objects.length; ++a1) {
      if ((player = V.map.manager.objects[a1]).uid == a0) {
        player.active = false;
        player.destroyed = true;
        if (RENDER && player.meshRef != null) {
          if (
            RENDER.shaderRendering &&
            UTILS.isNumber(player.meshRef) &&
            player.type != null
          ) {
            RENDER.ShaderMesh.visibility(player, false);
          } else {
            player.meshRef.visible = false;
          }
        }
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        break;
      }
    }
  };
  this.respawnObj = function (a0) {
    for (var a1 = 0; a1 < V.map.manager.objects.length; ++a1) {
      if ((player = V.map.manager.objects[a1]).uid == a0) {
        V.map.manager.destObjs.splice(
          V.map.manager.destObjs.indexOf(player.uid),
          1,
        );
        player.active = true;
        player.destroyed = false;
        if (player.health != null) {
          player.health = player.startHealth;
        }
        if (RENDER && player.meshRef != null) {
          if (
            RENDER.shaderRendering &&
            UTILS.isNumber(player.meshRef) &&
            player.type != null
          ) {
            RENDER.ShaderMesh.visibility(player.meshRef, true);
          } else {
            player.meshRef.visible = true;
          }
        }
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        break;
      }
    }
  };
  this.resetSites = function () {
    for (var a0 = 0; a0 < V.map.manager.sites.length; ++a0) {
      if ((player = V.map.manager.sites[a0]).meshRef) {
        var a1 = !!V.mode && !!V.mode.site;
        player.meshRef.visible = a1;
      }
    }
  };
  // CAP FLAG:
  this.capFlag = function (a0, a1) {
    if (io) {
      a0.caps++;
      a0.flag = null;
      V.players.teamScore(a0, 1);
      window.IO.broadcast(
        "game" + V.sid,
        "ac",
        a0.sid,
        null,
        "captured the Flag",
      );
      io.send(a0.id, "am", ["Capture", 150]);
      V.players.score(a0, 150);
      V.resetFlag(a1);
    }
  };
  // UPDATE FLAG COLOR:
  this.updateFlagCol = function (a0, a1) {
    if (a1 && a1.team && a0.teamCol != a1.team && a0.meshRef) {
      a0.teamCol = a1.team;
      a0.meshRef.material = RENDER.getMat(
        "crystal_0",
        V.map.manager.getFlagDat(a0.team, a1),
      );
      a0.meshRef.zoneMesh.material = RENDER.getMat(
        "zone_r",
        V.map.manager.getZoneDat(a0.team, a1),
      );
    }
  };
  // UPDATE FLAGS ON CLIENT:
  this.updateFlags = function (a0, a1) {
    if (V.mode && V.mode.flags) {
      var a2 = false;
      var a3 = false;
      for (var a4 = 0; a4 < V.map.manager.flags.length; ++a4) {
        if ((player = V.map.manager.flags[a4]).meshRef) {
          if (a0) {
            V.updateFlagCol(player, a0);
          }
          if (player.carrier) {
            if (a0 && player.team == a0.team) {
              a3 = true;
            }
            if (a0 && player.carrier == a0.sid) {
              a2 = true;
            }
            if ((Q = V.players.findBySid(player.carrier))) {
              Q.isYou;
              RENDER.moveMesh(
                player.meshRef,
                Q.x,
                Q.y + globalConfig.flagHOff,
                Q.z,
              );
              if (
                Q.objInstances &&
                player.meshRef.visible != Q.objInstances.visible
              ) {
                player.meshRef.visible = Q.objInstances.visible;
              }
            }
          } else {
            if (!player.meshRef.visible) {
              player.meshRef.visible = true;
            }
            RENDER.moveMesh(player.meshRef, player.x, player.y, player.z);
          }
          player.bobAnimY = (player.bobAnimY || 0) + a1 * 0.003;
          player.meshRef.position.y += Math.cos(player.bobAnimY);
          player.meshRef.rotation.y += a1 * 0.002;
        }
      }
      if (a3 && a2) {
        if (gameMessage.textContent != globalConfig.flagMsgRC) {
          gameMessage.textContent = globalConfig.flagMsgRC;
        }
      } else if (a3) {
        if (gameMessage.textContent != globalConfig.flagMsgE) {
          gameMessage.textContent = globalConfig.flagMsgE;
        }
      } else if (a2) {
        if (gameMessage.textContent != globalConfig.flagMsg) {
          gameMessage.textContent = globalConfig.flagMsg;
        }
      } else if (gameMessage.textContent != "") {
        gameMessage.textContent = "";
      }
      if (specGMessage.textContent != gameMessage.textContent) {
        specGMessage.textContent = gameMessage.textContent;
      }
    }
  };
  // UPDATE FLAG:
  this.updateFlag = function (a0, a1, a2, a3, a4) {
    for (var a5 = 0; a5 < V.map.manager.flags.length; ++a5) {
      if ((player = V.map.manager.flags[a5]).uid == a0) {
        player.carrier = a4;
        player.img.x = a1;
        player.img.y = a2;
        player.img.z = a3;
        V.moveObj(player, a1, a2, a3);
        break;
      }
    }
  };
  // DROP FLAG:
  this.dropFlag = function (a0) {
    if (io && a0 && a0.carrier) {
      var a1 = V.players.findBySid(a0.carrier);
      V.updateCarrier(a0);
      if (a1) {
        window.IO.broadcast(
          "game" + V.sid,
          "ac",
          a1.sid,
          null,
          "dropped the Flag",
        );
        V.updateFlagInfo(a0, "AWAY");
        a1.flag = null;
        V.updateObjPos(a0, a1.x, a1.y + globalConfig.flagOff, a1.z);
      } else {
        V.updateObjPos(a0, a0.orgX, a0.orgY, a0.orgZ);
      }
    }
  };
  // PICKUP FLAG:
  this.pickupFlag = function (a0, a1) {
    if (io && V.mode && V.mode.flags && !a1.carrier) {
      if (a0.team == a1.team) {
        if (a1.x != a1.orgX || a1.y != a1.orgY || a1.z != a1.orgZ) {
          window.IO.broadcast(
            "game" + V.sid,
            "ac",
            a0.sid,
            null,
            "returned the Flag",
          );
          io.send(a0.id, "am", ["Return", 50]);
          V.players.score(a0, 50);
          V.resetFlag(a1);
        }
      } else if (!a0.flag) {
        io.send(a0.id, "am", ["Pickup", 20]);
        V.players.score(a0, 20);
        V.updateCarrier(a1, a0);
        V.updateFlagInfo(a1, a0.fakeName || a0.alias);
        window.IO.broadcast("game" + V.sid, "ac", a0.sid, null, "got the Flag");
      }
    }
  };
  // SYNC FLAG:
  this.syncFlag = function (a0) {
    window.IO.broadcast(
      "game" + V.sid,
      "ufl",
      a0.uid,
      a0.x.round(1),
      a0.y.round(1),
      a0.z.round(1),
      a0.carrier || 0,
    );
  };
  // UPDATE FLAG CARRIER:
  this.updateCarrier = function (a0, a1) {
    a0.carrier = a1 ? a1.sid : 0;
    if (a1) {
      a1.flag = a0;
      a0.flagTimer = globalConfig.flagUpdate;
    }
    V.syncFlag(a0);
  };
  this.resetFlags = function () {
    for (var a0 = 0; a0 < V.map.manager.flags.length; ++a0) {
      (player = V.map.manager.flags[a0]).carrier = null;
      player.x = player.orgX;
      player.y = player.orgY;
      player.z = player.orgZ;
      if (player.meshRef) {
        var a1 = !!V.mode && !!V.mode.flags;
        player.meshRef.visible = a1;
        player.meshRef.zoneMesh.visible = a1;
      }
    }
  };
  // RESET FLAG:
  this.resetFlag = function (a0) {
    V.updateObjPos(a0, a0.orgX, a0.orgY, a0.orgZ);
    V.updateCarrier(a0);
    V.updateFlagInfo(a0, "AT BASE");
  };
  this.updateFlagInfo = function (a0, a1) {
    V.teamFlags[a0.team] = a1;
    window.IO.broadcast(
      "game" + this.sid,
      "ufi",
      a0.team,
      V.teamFlags[a0.team],
    );
  };
  this.updateFlagPings = function (a0) {
    if (V.mode && V.mode.flags) {
      for (var a1 = 0; a1 < V.map.manager.flags.length; ++a1) {
        if ((player = V.map.manager.flags[a1]).carrier) {
          player.flagTimer -= a0;
          if (player.flagTimer <= 0) {
            if ((Q = V.players.findBySid(player.carrier))) {
              player.img.x = Q.x;
              player.img.y = Q.y + globalConfig.flagHOff;
              player.img.z = Q.z;
              player.flagTimer = globalConfig.flagUpdate;
              window.IO.broadcast(
                "game" + V.sid,
                "ufp",
                player.uid,
                player.img.x.round(1),
                player.img.y.round(1),
                player.img.z.round(1),
              );
            }
          }
        } else {
          player.img.x = player.x;
          player.img.y = player.y;
          player.img.z = player.z;
        }
      }
    }
  };
  this.updateFlagPing = function (a0, a1, a2, a3) {
    for (var a4 = 0; a4 < V.map.manager.flags.length; ++a4) {
      if ((player = V.map.manager.flags[a4]).uid == a0) {
        player.img.x = a1;
        player.img.y = a2;
        player.img.z = a3;
        break;
      }
    }
  };
  this.dropSpawnable = function (a0, a1) {
    if (io && a1) {
      var a2 = spawnables[a0];
      var a3 = spawnables.genObj(
        a0,
        null,
        a1.x,
        a1.y + a2.yOff,
        a1.z,
        a2.scale,
        a1.team,
        a2.timer,
      );
      a3.active = true;
      window.IO.broadcast(
        "game" + V.sid,
        "crsp",
        a0,
        a3.sid,
        a3.x.round(1),
        a3.y.round(1),
        a3.z.round(1),
        a3.team,
      );
      V.map.manager.spawnables[a3.sid] = a3;
    }
  };
  this.pickupSpawnable = function (a0, a1) {
    spawnables[a1.i].onPickup(V, io, a0, a1);
  };
  this.createSpawnable = function (a0, a1, a2, a3, a4, a5, a6) {
    var a7 = spawnables[a0];
    var a8 = RENDER.loadMesh(
      {
        src: a7.model,
        texSrc: a7.model,
        noGroup: true,
        noShadow: true,
        noFog: true,
        emissive: a7.emissive(a6, a5),
        noEmisTex: true,
      },
      a2,
      a3 + a7.yOff,
      a4,
      0,
      a7.scale,
      RENDER.scene,
    );
    var a9 = spawnables.genObj(a0, a1, a2, a3, a4, a7.scale, a5);
    a9.meshRef = a8;
    V.map.manager.spawnables[a1] = a9;
  };
  this.disposeSpawnable = function (a0) {
    for (var a1 in V.map.manager.spawnables) {
      if ((player = V.map.manager.spawnables[a1]).sid == a0) {
        RENDER.remove(player.meshRef);
        player.meshRef = null;
        delete V.map.manager.spawnables[a0];
        break;
      }
    }
  };
  this.updateSpawnables = function (a0, a1) {
    for (var a2 in V.map.manager.spawnables) {
      if ((player = V.map.manager.spawnables[a2]).meshRef) {
        RENDER.moveMesh(player.meshRef, player.x, player.y, player.z);
        player.bobAnimY = (player.bobAnimY || 0) + a1 * 0.003;
        player.meshRef.position.y += Math.cos(player.bobAnimY);
        player.meshRef.rotation.y += a1 * 0.002;
      } else if (io && player.active && player.timer) {
        player.timer -= a1;
        if (player.timer <= 0) {
          player.active = false;
          window.IO.broadcast("game" + V.sid, "dsp", player.sid);
          delete V.map.manager.spawnables[player.sid];
        }
      }
    }
  };
  this.resetSpawnables = function () {
    for (var a0 in V.map.manager.spawnables) {
      if ((player = V.map.manager.spawnables[a0]).meshRef) {
        RENDER.remove(player.meshRef);
      }
    }
    V.map.manager.spawnables = [];
  };
  this.updatePickup = function (a0, a1, a2, a3, a4) {
    var a5 = !!this.mode && !!this.mode.site;
    if ((player = this.map.manager.findByUid(a0, this.map.manager.pickups))) {
      if (RENDER) {
        Q = player.meshRef;
        var a6 = a4 || [Q.position.x, Q.position.y, Q.position.z];
        RENDER.scene.remove(player.meshRef);
        var a7 = this.weapons[a1 || 0];
        var a8 = a7.altSkin || {};
        player.meshRef = RENDER.loadMesh(
          {
            src: "weapons/" + a7.src + (a8.mid == null ? "" : "_" + a8.mid),
            texSrc:
              a8.mid == null
                ? a8.tex
                  ? a8.tex
                  : a8 && a8.id != null
                    ? "weapons/skins/" + a7.src + "_" + a8.id
                    : null
                : UTILS.getReModel(this.store, a8),
            tFilter: 1006,
            transparent: a8.opac != null || a7.seeThrough,
            noGroup: true,
            shadowsR: true,
            noFog: true,
          },
          ...a6,
          0,
          (a8.mScl || this.weapons[a1 || 0].scale) *
            (this.weapons[a1 || 0].equipment ? 2 : 1),
          RENDER.scene,
        );
        player.meshRef.rotation.copy(Q.rotation.clone());
        player.meshRef.visible =
          (!this.weapons[a1] || this.weapons[a1].type != 3 || a5) && a1 != null;
      }
      player.x = a4 ? a4[0] : player.orgX;
      player.y = a4 ? a4[1] : player.orgY;
      player.z = a4 ? a4[2] : player.orgZ;
      if (a2) {
        player.orgPickup = a2;
      }
      player.pickup = a1;
      player.active = a3;
    }
  };
  this.resetPickups = function () {
    var a0 = !!V.mode && !!V.mode.site;
    for (var a1 = 0; a1 < V.map.manager.pickups.length; ++a1) {
      player = V.map.manager.pickups[a1];
      if (io && player.pickupRand) {
        player.orgPickup = UTILS.getRandom(V.weapons.onlyWeapons);
      }
      player.pickup = player.orgPickup;
      player.x = player.orgX;
      player.y = player.orgY;
      player.z = player.orgZ;
      player.active =
        !V.weaponConfig[player.pickup] ||
        V.weaponConfig[player.pickup].type != 3 ||
        a0;
      if (RENDER) {
        Q = player.meshRef;
        RENDER.scene.remove(player.meshRef);
        var a2 = V.weapons[player.pickup];
        var a3 = a2.altSkin || {};
        player.meshRef = RENDER.loadMesh(
          {
            src: "weapons/" + a2.src + (a3.mid == null ? "" : "_" + a3.mid),
            texSrc:
              a3.mid == null
                ? a3.tex
                  ? a3.tex
                  : a3 && a3.id != null
                    ? "weapons/skins/" + a2.src + "_" + a3.id
                    : null
                : UTILS.getReModel(V.store, a3),
            tFilter: 1006,
            // transparent: a3.opac != null || a2.seeThrough,
            noGroup: true,
            noShadow: true,
            transparent: true,
            noFog: true,
          },
          player.x,
          player.y - globalConfig.pickupZoneH / 2 + globalConfig.pickupOff,
          player.z,
          0,
          a3.mScl || V.weapons[player.pickup].scale,
          RENDER.scene,
        );
        player.meshRef.rotation.copy(Q.rotation.clone());
        player.meshRef.visible =
          !V.weaponConfig[player.pickup] ||
          V.weaponConfig[player.pickup].type != 3 ||
          a0;
      }
    }
  };
  // PLAYER CAN SEE SOMETHING:
  this.canSee = function (
    origin,
    targetX,
    targetY,
    targetZ,
    padding,
    ignoreHeight,
    seeThroughTransparent,
  ) {
    if (!origin) {
      return false;
    }
    padding = padding || 0;
    var a7;
    var a8 = UTILS.getD3D(
      origin.x,
      origin.y,
      origin.z,
      targetX,
      targetY,
      targetZ,
    );
    var a9 = UTILS.direction2D(origin.z, origin.x, targetZ, targetX);
    var aa = UTILS.direction2D(
      UTILS.distance2D(origin.x, origin.z, targetX, targetZ),
      targetY,
      0,
      origin.y,
    );
    var ab = 1 / (a8 * Math.sin(a9 - Math.PI) * Math.cos(aa));
    var ac = 1 / (a8 * Math.cos(a9 - Math.PI) * Math.cos(aa));
    var ad = 1 / (a8 * Math.sin(aa));
    var ae = origin.y + (origin.height || 0) - globalConfig.cameraHeight;
    var af = ignoreHeight ? 0 : padding;
    for (var ag = 0; ag < this.map.manager.objects.length; ++ag) {
      if (
        !(a7 = this.map.manager.objects[ag]).noShoot &&
        a7.active &&
        (!a7.transparent || seeThroughTransparent)
      ) {
        var ah = UTILS.lineInRect(
          origin.x,
          origin.z,
          ae,
          ab,
          ac,
          ad,
          a7.x - Math.max(0, a7.width - padding),
          a7.z - Math.max(0, a7.length - padding),
          a7.y - Math.max(0, a7.height - af),
          a7.x + Math.max(0, a7.width - padding),
          a7.z + Math.max(0, a7.length - padding),
          a7.y + Math.max(0, a7.height - padding),
        );
        if (ah && ah < 1) {
          return ah;
        }
      }
    }
    var ai = this.map.terrain;
    if (ai) {
      var aj = ai.raycast(origin.x, -origin.z, ae, 1 / ab, -1 / ac, 1 / ad);
      if (aj) {
        return UTILS.getD3D(origin.x, origin.y, origin.z, aj.x, aj.z, -aj.y);
      }
    }
    return null;
  };
  this.increaseWeapon = function (a0, a1) {
    (player = a1.wId == null ? [...a0.loadout] : [a1.wId]).length = 1;
    var a2 = this.mode.weaponOrder.indexOf(player[0]);
    if (a2 > -1) {
      if (player[0] == this.mode.weaponOrder[a2 + 1]) {
        return;
      }
      player[0] =
        this.mode.weaponOrder[a2 + 1] == null
          ? this.mode.weaponOrder[this.mode.weaponOrder.length - 1]
          : this.mode.weaponOrder[a2 + 1];
      a0.weaponTier = a2 + 1;
    } else {
      player[0] = this.mode.weaponOrder[0];
      a0.weaponTier = 0;
    }
    window.IO.broadcast(
      "game" + this.sid,
      "inat",
      a0.sid,
      player,
      0,
      undefined,
      undefined,
      false,
    );
    a0.updateLoadout(this, 0, true, ...player);
  };
  this.decreaseWeapon = function (a0) {
    (player = [...a0.loadout]).length = 1;
    a0.weaponTier--;
    if (a0.weaponTier < 0) {
      a0.weaponTier = 0;
    } else {
      a0.setbacks++;
    }
    player[0] = this.mode.weaponOrder[a0.weaponTier];
    window.IO.broadcast(
      "game" + this.sid,
      "inat",
      a0.sid,
      player,
      0,
      undefined,
      undefined,
      false,
    );
    a0.updateLoadout(this, 0, true, ...player);
  };
  this.resetGates = function () {
    for (var a0 = 0; a0 < V.map.manager.gates.length; ++a0) {
      (player = V.map.manager.gates[a0]).active = !player.startClosed;
      if (RENDER && player.meshRef != null) {
        if (
          RENDER.shaderRendering &&
          UTILS.isNumber(player.meshRef) &&
          player.type != null
        ) {
          RENDER.ShaderMesh.visibility(player.meshRef, player.active);
        } else {
          player.meshRef.visible = player.active;
        }
      }
    }
  };
  this.updateBank = function (a0, a1) {
    for (var a2 = 0; a2 < V.map.manager.banks.length; ++a2) {
      if ((player = V.map.manager.banks[a2]).uid == a0) {
        player.deposited = a1;
        break;
      }
    }
  };
  this.resetBanks = function () {
    for (var a0 = 0; a0 < V.map.manager.banks.length; ++a0) {
      (player = V.map.manager.banks[a0]).deposited = 0;
    }
  };
  this.updateGate = function (a0, a1) {
    for (var a2 = 0; a2 < V.map.manager.gates.length; ++a2) {
      if ((player = V.map.manager.gates[a2]).uid == a0) {
        player.active = a1;
        if (RENDER && player.meshRef != null) {
          if (
            RENDER.shaderRendering &&
            UTILS.isNumber(player.meshRef) &&
            player.type != null
          ) {
            RENDER.ShaderMesh.visibility(player.meshRef, a1);
          } else {
            player.meshRef.visible = a1;
          }
        }
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        break;
      }
    }
  };
  // UPDATE OBJECT POS:
  this.updateObjPos = function (a0, a1, a2, a3) {
    a0.x = a1;
    a0.y = a2;
    a0.z = a3;
    a0.img.x = a1;
    a0.img.y = a2;
    a0.img.z = a3;
    V.syncFlag(a0);
  };
  // UPDATE BR ZONE:
  this.updateZone = function (a0) {
    V.map.zone.update(0, a0);
  };
  // RESET BR ZONE:
  this.resetZone = function () {
    if (V.map.zone) {
      V.map.zone.reset();
    }
  };
  // SET OBJECTIVE:
  this.setObjective = function (a0) {
    try {
      V.activeObjective = a0;
      for (var a1 = 0; a1 < V.map.manager.objectives.length; ++a1) {
        V.map.manager.objectives[a1].mesh.visible = a0 == a1;
      }
    } catch (a2) {}
  };
  // NEXT OBJECTIVE:
  this.nextObjective = function (a0, a1) {
    this.activeObjective++;
    if (this.activeObjective >= this.map.manager.objectives.length) {
      this.activeObjective = 0;
    }
    window.IO.broadcast("game" + this.sid, "obj", this.activeObjective);
    if (this.map.manager.objectives.length > 1) {
      var a2 = {
        time: 60000 - (a0 || 0),
        contTime: true,
        canDMG: true,
        msg: "next objective ",
        trigger: function (a3, a4) {
          a3.nextObjective(a4);
        },
      };
      if (a1 && this.waitTimers) {
        this.waitTimers.push(a2);
      } else {
        this.waitTimers = [a2];
      }
    }
  };
  this.setWeapon = function (a0) {
    try {
      V.activeObjective = a0;
    } catch (a1) {}
  };
  this.nextWeapon = function (a0, a1) {
    this.activeObjective = UTILS.getRandom(this.weapons.onlyWeapons);
    for (var a2 = 0; a2 < this.players.list.length; ++a2) {
      if (!this.players.list[a2].spectating) {
        this.players.list[a2].updateLoadout(
          this,
          0,
          true,
          this.activeObjective,
        );
      }
    }
    window.IO.broadcast("game" + this.sid, "inatA", [this.activeObjective], 0);
    window.IO.broadcast("game" + this.sid, "wep", this.activeObjective);
    var a3 = {
      time: 20000 - (a0 || 0),
      contTime: true,
      canDMG: true,
      msg: "next weapon in ",
      trigger: function (a4, a5) {
        a4.nextWeapon(a5);
      },
    };
    if (a1 && this.waitTimers) {
      this.waitTimers.push(a3);
    } else {
      this.waitTimers = [a3];
    }
  };
  this.setCheckPoint = function (a0, a1) {
    if (
      (!a0.checkPoint || a0.checkPoint != a1.uid) &&
      (!a1.team || !V.mode || !V.mode.teams || a1.team == a0.team)
    ) {
      if (a1.singleUse) {
        if (a0.checkPointList.indexOf(a1.uid) > -1) {
          return;
        }
        a0.checkPointList.push(a1.uid);
      }
      a0.checkPoint = a1.uid;
      if (io) {
        io.send(a0.id, "chp");
      }
    }
  };
  this.checkTeleport = function (a0, a1) {
    if (
      a1.node != 1 &&
      !(a1.telCooldown > 0) &&
      (!a1.team || !V.mode || !V.mode.teams || a1.team == a0.team)
    ) {
      for (var a2 = 0; a2 < this.map.manager.teleporters.length; ++a2) {
        if (
          (player = this.map.manager.teleporters[a2]).channel == a1.channel &&
          player.node > 0 &&
          a1.uid != player.uid &&
          (!player.team || !V.mode || !V.mode.teams || player.team == a0.team)
        ) {
          if (player.node == 2) {
            player.telCooldown = 2000;
          }
          V.players.changePosition(
            a0,
            player.x,
            player.y - player.height,
            player.z,
            false,
            player.telStopMo,
            player.forceDir ? player.dir : undefined,
          );
          break;
        }
      }
    }
  };
  this.updateTeleporters = function (a0) {
    if (V.map.manager.teleporters.length) {
      for (var a1 = 0; a1 < V.map.manager.teleporters.length; ++a1) {
        (player = V.map.manager.teleporters[a1]).telCooldown -= a0;
        if (player.telCooldown <= 0) {
          player.telCooldown = 0;
        }
      }
    }
  };
  this.updateDestructables = function (a0) {
    if (io && this.map.manager.destObjs.length) {
      for (var a1 = this.map.manager.destObjs.length - 1; a1 >= 0; --a1) {
        if (
          (player = this.map.manager.objects[this.map.manager.destObjs[a1]]) &&
          player.canRespawn
        ) {
          if (!player.respawnT && player.respawnR) {
            player.respawnT = UTILS.randInt(1, 5000);
          }
          player.respawnT -= a0;
          if (player.respawnT <= 0) {
            this.map.manager.destObjs.splice(a1, 1);
            player.active = true;
            player.destroyed = false;
            player.respawnT = player.respawnR ? 0 : player.respawnTStart;
            if (player.health != null) {
              player.health = player.startHealth;
            }
            window.IO.broadcast("game" + this.sid, "ro", player.uid);
            if (player && player.onRespawn && player.destroyedBy) {
              this.onTrigger(player.destroyedBy, player);
            }
            player.destroyedBy = null;
          }
        }
      }
    }
  };
  // CREATE INSTANCE CONFIG:
  this.instanceConfig = function () {};
  // VOTE ON MODE:
  this.voteMatch = function (a0, a1) {
    if (this.endData.vo) {
      this.endData.vo[a0] = this.endData.vo[a0] == a1 ? null : a1;
      window.IO.broadcast(
        "game" + this.sid,
        "mv",
        this.endData.vo,
        this.endData.mts,
      );
    }
  };
  var Z = [];
  // the big init...
  // INIT:
  this.init = function (mapIndex, modeIndex, genMap, a3) {
    this.initInProgress = true;
    this.players.clear();
    this.AI.reset();
    this.teamFlags = [];
    this.teams = {};
    Z.length = 0;
    var endData = null;
    if (this.endData.mts.length) {
      for (var a5 = 0; a5 < this.endData.mts.length; ++a5) {
        0;
        Z[a5] = 0;
        if (this.endData.vo) {
          for (var a6 in this.endData.vo) {
            if (
              this.endData.vo.hasOwnProperty(a6) &&
              this.endData.mts[a5] == this.endData.vo[a6]
            ) {
              Z[a5]++;
            }
          }
        }
      }
      var a7 = 0;
      for (a5 = 0; a5 < Z.length; ++a5) {
        if (Z[a5] > a7) {
          a7 = Z[a5];
          endData = this.endData.mts[a5];
        }
      }
      if (a7 == 0) {
        endData = this.endData.mts[0] || null;
      }
    }
    if (endData != null) {
      var a8 = endData.split(",");
      this.modeIndex = parseInt(a8[0]);
      this.mapIndex = parseInt(a8[1]);
    } else {
      this.modeIndex =
        modeIndex == null
          ? this.config.modes
            ? this.config.modes[UTILS.randInt(0, this.config.modes.length - 1)]
            : UTILS.randInt(0, 3)
          : modeIndex;
      this.mapIndex =
        mapIndex == null
          ? this.config.maps[UTILS.randInt(0, this.config.maps.length - 1)]
          : mapIndex;
    }
    this.mode = modes[this.modeIndex];
    if (a3) {
      return this.map
        .asyncGenerate(this.mapIndex, this.mode, genMap, this.isCustom)
        .then(this.finishInit.bind(this));
    } else {
      this.map.generate(this.mapIndex, this.mode, genMap, this.isCustom);
      this.finishInit();
      return Promise.resolve();
    }
  };
  this.finishInit = function () {
    if (!this.isDestroyed) {
      this.map.manager.resetAll();
      this.resetFlags();
      this.resetSpawnables();
      this.resetPickups();
      this.resetGates();
      this.resetBanks();
      this.resetZone();
      this.resetSites();
      this.activeBomb = null;
      this.map.manager.addPendingAIs(this.AI);
      this.forceSpawn = this.config.forceSpawn || this.mode.forceSpawn;
      this.minPlayers = this.config.minPlayers || this.mode.minPlayers;
      if (!this.minPlayers && (this.config.lives || this.mode.lives || 0)) {
        this.minPlayers = 2;
      }
      this.voteToKick = null;
      this.voteInitiators.length = 0;
      this.needAllTimer = 50000;
      this.zoneTimer = 0;
      this.nukeTimer = 0;
      this.objectiveTimer = 0;
      this.activeObjective = null;
      // Keep static-map behavior only when explicitly map-locked/custom.
      this.gameTimer =
        this.forceStaticMap === true
          ? 240000
          : this.mode.gameTime == null
            ? this.config.gameTime * 60000
            : this.mode.gameTime;
      this.lastTimer = 0;
      this.lastTimerW = 0;
      this.lastTimerNA = 0;
      this.waitTimers = null;
      if (this.mode.waitTimers) {
        this.waitTimers = [];
        for (var a0 = 0; a0 < this.mode.waitTimers.length; ++a0) {
          this.waitTimers.push({
            time: this.mode.waitTimers[a0].time,
            trigger: this.mode.waitTimers[a0].trigger,
            noJoin: this.mode.waitTimers[a0].noJoin,
            msg: this.mode.waitTimers[a0].msg,
            noClear: this.mode.waitTimers[a0].noClear,
            comp: this.mode.waitTimers[a0].comp,
          });
        }
      } else if (
        (this.config.lives || this.mode.lives) &&
        !this.config.warmupTime &&
        !this.mode.warmupTime
      ) {
        this.waitTimers = [
          {
            time: 12000,
            msg: "match starts in ",
            trigger: function (a8) {
              for (var a9 = 0; a9 < a8.players.list.length; ++a9) {
                if (a8.players.list[a9].spectating) {
                  a8.players.list[a9].lives = 0;
                }
              }
            },
          },
        ];
      }
      if (this.config.warmupTime || this.mode.warmupTime) {
        if (!this.waitTimers) {
          this.waitTimers = [];
        }
        this.waitTimers.unshift({
          time: 10000,
          comp: true,
          msg: "match starting in ",
          trigger: function (a8) {
            for (var a9 = 0; a9 < a8.players.list.length; ++a9) {
              if (a8.players.list[a9].spectating) {
                a8.players.list[a9].lives = 0;
              }
            }
            a8.unlockMove();
          },
        });
        this.waitTimers.unshift({
          time: (this.config.warmupTime || this.mode.warmupTime) * 60000,
          msg: "warmup ends ",
          comp: true,
          trigger: function (a8) {
            a8.warmupReset();
            a8.lockMove();
          },
        });
      }
      this.condition = this.mode.condition ? [...this.mode.condition] : null;
      if (this.config.lives || this.mode.lives) {
        if (!this.condition) {
          this.condition = [];
          if (this.mode.teamOptions || !this.mode.teams) {
            this.condition.push(function (a8) {
              var a9 = 0;
              for (var aa = 0; aa < a8.players.list.length; ++aa) {
                if (a8.players.list[aa].lives > 0) {
                  a9++;
                }
              }
              return a9 > 1;
            });
          } else {
            this.condition.push(function (a8) {
              var a9 = 0;
              var aa = 0;
              for (var ab = 0; ab < a8.players.list.length; ++ab) {
                if (a8.players.list[ab].lives > 0) {
                  if (a8.players.list[ab].team == 1) {
                    a9++;
                  } else {
                    aa++;
                  }
                }
              }
              return a9 >= 1 && aa >= 1;
            });
          }
        }
        if (!this.winCondition) {
          if (this.mode.teamOptions || !this.mode.teams) {
            this.winCondition = function (a8) {
              for (var a9 = 0; a9 < a8.players.list.length; ++a9) {
                if (a8.players.list[a9].lives > 0) {
                  return a8.players.list[a9];
                }
              }
              return null;
            };
          } else {
            this.winCondition = function (a8) {
              for (var a9 = 0; a9 < a8.players.list.length; ++a9) {
                if (a8.players.list[a9].team && a8.players.list[a9].lives > 0) {
                  return a8.players.list[a9].team;
                }
              }
              return 1;
            };
          }
        }
      }
      this.scoreLimit = this.config.scoreLimit || this.mode.scoreLimit || 0;
      if (this.scoreLimit) {
        if (!this.condition) {
          this.condition = [];
        }
        if (this.mode.teamOptions || !this.mode.teams) {
          this.condition.push(function (a8) {
            for (var a9 = 0; a9 < a8.players.list.length; ++a9) {
              if (a8.players.list[a9].score >= a8.scoreLimit) {
                return 0;
              }
            }
            return 1;
          });
        } else {
          this.condition.push(function (a8) {
            for (var a9 in a8.teams) {
              if (
                a8.teams.hasOwnProperty(a9) &&
                a8.teams[a9] >= a8.scoreLimit
              ) {
                return 0;
              }
            }
            return 1;
          });
        }
      }
      this.kills = 0;
      if (io && this.mode.gameStart) {
        this.mode.gameStart(this);
      }
      if (SOUND) {
        SOUND.rate = 1;
        var a1 = this.mode.ambInd || this.map.maps[this.mapIndex].ambInd || 1;
        if ((a1 = parseInt(a1)) != W) {
          if (W != null) {
            SOUND.stop("ambient_" + W);
          }
          W = a1;
          SOUND.play(
            "ambient_" + a1,
            globalConfig.amvVols[a1] || 0.12,
            true,
            1,
          );
        }
      }
      var a2 = this.customMapData ? this.customMapData.id : 0;
      if (serverManager) {
        var a3 = {
          mC: this.maxPlayers,
          pv: this.private,
          sk: !this.isCustom,
          pgi: this.pendingGameId,
          data: {
            cs: this.isCustom,
            i: this.getInfo(),
            v: version,
            m: a2,
          },
        };
        if (this.config.promServ) {
          a3.data.pr = 1;
        }
        if (this.gameInstance) {
          this.gameInstance.update(a3);
        } else {
          this.gameInstance = serverManager.createGame(serverPort, a3);
          this.gameInstance.initiationPromise.then(() => {
            this.updatedGameInstance = true;
            window.IO.broadcast(
              "game" + this.sid,
              "inst-id",
              this.gameInstance.id,
            );
          });
          if (io && !globalConfig.isProd) {
            var fs = require("fs");
            var process = require("process");
            var versionPath = path.join(process.cwd(), "version.json");
            fs.watchFile(
              versionPath,
              {
                interval: 100,
              },
              () => {
                a3.data.v = version = JSON.parse(
                  fs.readFileSync(versionPath, "utf8"),
                );
                this.gameInstance.update(a3);
              },
            );
          }
        }
      }
      this.initInProgress = false;
      for (var a7 of this.initQueue) {
        a7();
      }
      this.initQueue.length = 0;
    }
  };
  this.leaveGame = function (a0, a1) {
    var a2 = this.host == a0;
    if (this.config.isFromQueue ? this.connectedClients <= 0 : a2) {
      this.destroyGame(a2);
    } else if (this.mode && this.mode.needAll) {
      this.endGame(3);
    } else if (a1) {
      window.IO.broadcast(
        "game" + this.sid,
        "ch",
        null,
        globalConfig.serverMessages[a1.t].replace("$", a1.n),
        2,
      );
    }
  };
  this.startQueuedGame = function () {
    this.config.isFromQueue;
  };
  // GET TEAM SCORES:
  this.getTeamScores = function () {
    var a0 = null;
    if (this.mode && this.mode.teams && this.teams) {
      a0 = [
        [1, this.teams[1] || 0, this.teamFlags[1] || null],
        [2, this.teams[2] || 0, this.teamFlags[2] || null],
      ];
    }
    return a0;
  };
  // GET SYNC DATA:
  this.getSyncData = function () {
    var a0 = [];
    var a1 = [];
    var a2 = [];
    var a3 = [];
    var a4 = [];
    for (var a5 = 0; a5 < this.map.manager.flags.length; ++a5) {
      player = this.map.manager.flags[a5];
      a0.push([
        player.uid,
        player.x.round(1),
        player.y.round(1),
        player.z.round(1),
        player.carrier || 0,
        player.flagTimer,
      ]);
    }
    for (var a6 in this.map.manager.spawnables) {
      player = this.map.manager.spawnables[a6];
      a1.push([
        player.i,
        player.sid,
        player.x.round(1),
        player.y.round(1),
        player.z.round(1),
        player.timer,
      ]);
    }
    for (a5 = 0; a5 < this.map.manager.pickups.length; ++a5) {
      player = this.map.manager.pickups[a5];
      a4.push([
        player.uid,
        player.pickup,
        player.orgPickup || 0,
        player.active,
        [player.x, player.y, player.z],
      ]);
    }
    for (a5 = 0; a5 < this.map.manager.gates.length; ++a5) {
      player = this.map.manager.gates[a5];
      a2.push([player.uid, player.active]);
    }
    for (a5 = 0; a5 < this.map.manager.banks.length; ++a5) {
      player = this.map.manager.banks[a5];
      a3.push([player.uid, player.deposited]);
    }
    return {
      dest: this.map.manager.destObjs.length ? this.map.manager.destObjs : 0,
      flg: a0.length ? a0 : 0,
      spwns: a1.length ? a1 : 0,
      gor: 1,
      pkups: a4.length ? a4 : 0,
      gates: a2.length ? a2 : 0,
      banks: a3.length ? a3 : 0,
      bill: this.billboard,
      zone: this.map.zone ? this.map.zone.getData() : 0,
      lck: this.moveLock ? 1 : 0,
    };
  };
  this.triggerChains = {};
  this.onTrigger = function (a0, a1, a2) {
    if (
      io &&
      this.triggers.actions[a1.triggerAction] &&
      (!a1.team || !V.mode || !V.mode.teams || (a0 && a1.team == a0.team))
    ) {
      if (a1.singleUse && a1.triggered) {
        return;
      }
      if (a1.triggerChance && !(UTILS.randInt(0, 100) <= a1.triggerChance)) {
        return;
      }
      a1.triggered = true;
      if (a2 == null) {
        a2 = a1.uid;
        this.triggerChains[a2] = globalConfig.triggerLimit;
      }
      if (this.triggerChains[a2] <= 0) {
        return;
      }
      this.triggerChains[a2]--;
      this.triggers.actions[a1.triggerAction].execute(
        this,
        io,
        a0,
        a1,
        a2,
        UTILS,
      );
      if (a1.selfDestruct) {
        this.triggers.actions[24].execute(this, io, a0, a1, a2, UTILS);
      }
    }
  };
  this.foundEventItem = function (a0, a1) {};
  this.getItemByChance = function (a0) {
    var a1 = [];
    var a2 = UTILS.randFloat(0.01, 100);
    var a3 = 0;
    var a4 = 0;
    for (var a5 = 0; a5 < V.store.rarities.length; ++a5) {
      if (a2 < (a4 += V.store.lootRars[a5] || 0)) {
        a3 = a5;
        break;
      }
    }
    for (a5 = 0; a5 < a0.length; ++a5) {
      var a6 = parseInt(a0[a5]);
      var a7 = V.store.skins[a6];
      if (a6 < 0) {
        for (var a8 = 0; a8 < -a6; ++a8) {
          a1.push(-1);
        }
      } else if (a7 && a7.rarity == a3) {
        a1.push(a6);
      }
    }
    return parseInt(a1[UTILS.randInt(0, a1.length - 1)]);
  };
  this.giveSkin = function (a0, a1) {
    if (
      io &&
      V.store.skins[a1] &&
      a0.account &&
      !a0.account.hack &&
      !this.isCustom
    ) {
      dbClient.call(18, [a0.account.id, a1, 0, false], function (a2, a3) {
        if (
          !a2 &&
          !(a2 = (a3 = a3 && a3[0] ? a3[0][0] : null)
            ? a3.error_text
            : "Error occured.") &&
          a0.account
        ) {
          if (a0.account.skins.some((a5) => a5.ind === a1)) {
            var a4 = a0.account.skins.find((a5) => a5.ind === a1);
            if (a4) {
              a4.cnt++;
            }
          } else {
            a0.account.skins.push({
              ind: a1,
              cnt: 1,
            });
          }
          io.send(a0.id, "skin", a1);
        }
      });
    }
  };
  // END GAME:
  this.endGame = function (a0) {
    // Static-map sessions can keep looping one round forever.
    if (this.forceStaticMap === true) {
      this.gameTimer = 240000;
      this.endTimer = 0;
      this.lastTimer = 0;
      return;
    }
    this.endTimer = this.mode.infEndTimer ? "inf" : globalConfig.endTimer;
    this.endIndex = a0 == null ? null : a0;
    this.waitTimers = null;
    if (this.mode.endSort) {
      this.players.list.sort(this.mode.endSort);
    } else {
      this.players.list.sort(UTILS.orderByScore);
    }
    if (this.endIndex != null) {
      var a1 =
        this.mode.gameTime == null
          ? this.config.gameTime * 60000
          : this.mode.gameTime;
      if (this.gameTimer / a1 < 0.5 && this.endIndex == 3) {
        if (this.mode.teams && this.teams) {
          var a2 = 0;
          var a3 = 0;
          for (var a4 = 0; a4 < this.players.list.length; ++a4) {
            if ((player = this.players.list[a4]).team == 1) {
              a2++;
            } else {
              a3++;
            }
          }
          this.winner = a2 == a3 ? null : a2 > a3 ? 1 : 2;
        } else {
          this.winner = this.players.list[0];
        }
      } else {
        this.winner = null;
      }
    } else if (this.mode.winCondition) {
      this.winner = this.mode.winCondition(this);
    } else if (this.mode.teams && this.teams) {
      var a5 = 0;
      var a6 = null;
      for (var a7 in this.teams) {
        if (this.teams.hasOwnProperty(a7) && this.teams[a7] >= a5) {
          a5 = this.teams[a7];
          a6 = a7;
        }
      }
      this.winner = a5 == 0 ? null : a6;
    } else {
      this.winner = this.players.list[0];
    }
    for (a4 = 0; a4 < this.players.list.length; ++a4) {
      (player = this.players.list[a4]).didWin =
        (player.team && player.team == this.winner) || player == this.winner;
    }
    if (this.mode.isRanked) {
      this.updateELO();
    }
    if (this.host == null && this.endIndex == null) {
      for (a4 = 0; a4 < this.players.list.length; ++a4) {
        (player = this.players.list[a4]).reward = 0;
        if (player.account && !player.account.hack && !player.kpdData) {
          var a8 = player.score * (this.mode.rewardMlt || 1);
          player.reward = Math.min(
            player.account.premiumT ? 40 : 30,
            Math.floor(a8 / 100),
          );
          if (player.challMode) {
            player.reward = Math.floor(player.reward * 1.5);
          }
        }
      }
    }
    var a9 = this.mode.endStats || globalConfig.endStats;
    this.endData.modeIndex = this.modeIndex || 0;
    this.endData.vo = {};
    this.endData.tms = this.getTeamScores();
    let aa = this.config ? this.config.modes || this.map.rotationModes : null;
    let ab = this.config.maps || this.map.rotationMaps;
    this.endData.mts.length = 0;
    var ac = 0;
    var ad = aa.indexOf(0) > -1;
    if (this.forceRaid) {
      this.forceRaid = false;
      this.endData.mts = [, , , ,].fill("23,13");
    } else {
      while (this.endData.mts.length < 4) {
        let ah =
          ac == 0 && ad
            ? 0
            : aa
              ? aa[UTILS.randInt(0, aa.length - 1)]
              : UTILS.getRandom(this.map.rotationModes);
        let ai = ab[UTILS.randInt(0, ab.length - 1)];
        if (this.endData.mts.indexOf(ah + "," + ai) < 0) {
          this.endData.mts.push(ah + "," + ai);
        }
        if (++ac > 20) {
          break;
        }
      }
      if (
        !this.isCustom &&
        this.endData.mts &&
        this.endData.mts.length &&
        UTILS.randInt(0, 2) == 0
      ) {
        this.endData.mts[this.endData.mts.length - 1] = "23,13";
      }
    }
    for (a4 = 0; a4 < this.players.list.length; ++a4) {
      (player = this.players.list[a4]).reset();
      this.endData.ed.length = 0;
      for (var ae = 0; ae < this.players.list.length; ++ae) {
        if (!this.players.list[ae].kpdData) {
          for (var af = 0; af < a9.length; ++af) {
            if (a9[af] == "name") {
              this.endData.ed.push([
                this.players.list[ae].getName(
                  player.account,
                  false,
                  player.kpdData,
                ),
                this.players.list[ae].getName(
                  player.account,
                  true,
                  player.kpdData,
                ),
              ]);
            } else {
              this.endData.ed.push(
                globalConfig.endForm[a9[af]]
                  ? globalConfig.endForm[a9[af]](
                      this.players.list[ae][a9[af]],
                      this,
                      this.players.list[ae],
                    )
                  : this.players.list[ae][a9[af]],
              );
            }
          }
        }
      }
      if (player.account && !this.isCustom) {
        player.account.playedMatch = true;
      }
      var ag = player.account
        ? [
            player.account.clanKills,
            player.clanKillsP,
            player.account.clanDeaths,
            player.clanDeathsP,
          ]
        : null;
      io.send(
        player.id,
        "end",
        false,
        this.winner || this.endIndex == 3 ? player.didWin : -1,
        this.endData,
        this.mode.teams && (this.winner || this.endIndex == 3)
          ? this.winner
          : -1,
        ag,
        player.account && player.account.playedMatch,
      );
    }
    this.endData.ed.length = 0;
    for (ae = 0; ae < this.players.list.length; ++ae) {
      if (!this.players.list[ae].kpdData) {
        for (af = 0; af < a9.length; ++af) {
          if (a9[af] == "name") {
            this.endData.ed.push([
              this.players.list[ae].getName(1, true, false),
            ]);
          } else {
            this.endData.ed.push(
              globalConfig.endForm[a9[af]]
                ? globalConfig.endForm[a9[af]](
                    this.players.list[ae][a9[af]],
                    this,
                    this.players.list[ae],
                  )
                : this.players.list[ae][a9[af]],
            );
          }
        }
      }
    }
    this.updateAccounts();
    this.players.clear();
  };
  // UPDATE FUNCTION:
  this.update = function (a0, a1, a2) {
    this.now = a1;
    if (io) {
      if (this.initInProgress) {
        return;
      }
      var a3 = true;
      if (this.endTimer > 0) {
        a3 = false;
        this.endTimer -= a0;
        if (this.endTimer <= 0) {
          // [patched] Do NOT auto-call init() here. The server-side wrapper
          // (main/gameserver.js) detects endTimer hitting 0 and runs its own
          // cycleToMap(winningMap) which goes through the proper player
          // re-add / spawn / start handshake. Just freeze the timer and let
          // the wrapper take over.
          this.endTimer = 0;
        } else if ((U = UTILS.getTime(this.endTimer)) != this.lastTimer) {
          this.lastTimer = U;
          window.IO.broadcast("game" + this.sid, "t", U, 1);
        }
      } else if (this.endTimer == "inf") {
        if (this.endTimer != this.lastTimer) {
          this.lastTimer = this.endTimer;
          window.IO.broadcast(
            "game" + this.sid,
            "t",
            "inf",
            this.endIndex || 2,
          );
        }
      } else if (this.waitTimers) {
        a3 = false;
        if (
          !this.waitTimers[0].contTime &&
          this.minPlayers &&
          this.players.activeCount() < this.minPlayers
        ) {
          if (this.mode.needAll) {
            this.needAllTimer -= a0;
            if (this.needAllTimer <= 0) {
              this.endGame(3);
            } else if (
              (U = UTILS.getTime(this.needAllTimer)) != this.lastTimerNA
            ) {
              this.lastTimerNA = U;
              window.IO.broadcast("game" + this.sid, "gmsg", "wt", U);
            }
          } else {
            window.IO.broadcast("game" + this.sid, "gmsg", "wt");
          }
        } else {
          this.waitTimers[0].time -= a0;
          if (this.waitTimers[0].time <= 0) {
            if (this.waitTimers[0].trigger) {
              this.waitTimers[0].trigger(this, -this.waitTimers[0].time, io);
            }
            if (this.waitTimers[0].time <= 0) {
              var a4 = !!this.waitTimers[0].noClear;
              this.waitTimers.splice(0, 1);
              if (!this.waitTimers.length) {
                this.waitTimers = null;
                if (!a4) {
                  window.IO.broadcast("game" + this.sid, "gmsg");
                }
              }
            }
          } else if (
            (U = UTILS.getTime(this.waitTimers[0].time)) != this.lastTimerW
          ) {
            this.lastTimerW = U;
            window.IO.broadcast(
              "game" + this.sid,
              "gmsg",
              this.waitTimers[0].msg + U,
            );
          }
        }
      }
      if (
        this.endTimer <= 0 &&
        (a3 || (this.waitTimers && this.waitTimers[0].contTime))
      ) {
        // [patched] disable score/lives "skip" conditions that would force a game end.
        if (this.mode.timed) {
          this.gameTimer += a0;
          if (
            (U = UTILS.getTime(this.gameTimer, this.mode.showMS)) !=
            this.lastTimer
          ) {
            this.lastTimer = U;
            window.IO.broadcast("game" + this.sid, "t", U);
          }
        } else {
          if (typeof this.gameTimer != "number" || this.gameTimer <= 0) {
            this.gameTimer = 240000;
          }
          this.gameTimer -= a0;
          if (this.gameTimer <= 0) {
            // [patched] trigger end-of-round flow so the engine builds map
            // vote candidates and sends "end" + "mv" packets. The server
            // wrapper drives the actual cycle once endTimer expires.
            this.gameTimer = 0;
            this.lastTimer = -1; // force fresh "t" broadcast next branch
            this.endGame(3);
            return; // skip stale gameTimer "t" broadcast this tick
          }
          if (
            (U = UTILS.getTime(this.gameTimer, this.mode.showMS)) !=
            this.lastTimer
          ) {
            this.lastTimer = U;
            window.IO.broadcast("game" + this.sid, "t", U);
          }
        }
      }
      if (
        this.endTimer <= 0 &&
        this.nukeTimer &&
        ((this.nukeTimer -= a0),
        this.nukeTimer <= 0 &&
          ((this.nukeTimer = 0),
          window.IO.broadcast("game" + this.sid, "n", 1),
          this.nukePlayer))
      ) {
        var a6 = 0;
        for (a5 = 0; a5 < this.players.list.length; ++a5) {
          if (
            !!(player = this.players.list[a5]).active &&
            player != this.nukePlayer &&
            (!player.team || this.nukePlayer.team != player.team) &&
            !player.godMode
          ) {
            a6 += 50;
            this.players.kill(
              player,
              this.nukePlayer,
              {
                stk: 0,
              },
              false,
              true,
            );
          }
        }
        if (a6) {
          io.send(
            this.nukePlayer.id,
            "6",
            ["Nuke", a6],
            0,
            this.nukePlayer.kills,
            a6 / 50,
          );
          io.send(this.nukePlayer.id, "4");
          this.players.score(this.nukePlayer, a6);
        }
      }
      if (this.voteToKick) {
        this.voteToKick.timer -= a0;
        if (this.voteToKick.timer <= 0) {
          this.voteToKick = null;
          window.IO.broadcast("game" + this.sid, "vk", null);
        }
      }
      this.updateBomb(a0);
      this.updateFlagPings(a0);
      this.updateSpawnables(null, a0);
      for (a5 = 0; a5 < this.map.manager.timerObjs.length; ++a5) {
        if (
          !!(player =
            this.map.manager.objects[this.map.manager.timerObjs[a5]]) &&
          !(player.triggerTimer <= 0) &&
          !!player.active
        ) {
          player.triggerTimer -= a0;
          if (player.triggerTimer <= 0) {
            player.triggerTimer = (player.triggerConstantEvent || 0) * 1000;
            this.onTrigger(null, player);
          }
        }
      }
    }
    this.players.update(a0 * this.config.deltaMlt);
    this.AI.update(a0 * this.config.deltaMlt);
    this.updateTeleporters(a0);
    this.updateDestructables(a0);
    if (
      io &&
      this.mode.objective &&
      this.map.manager.objectives.length &&
      this.waitTimers &&
      this.waitTimers[0].contTime &&
      ((this.objectiveTimer -= a0), this.objectiveTimer <= 0)
    ) {
      this.objectiveTimer = 1500;
      for (a5 = 0; a5 < this.map.manager.objectives.length; ++a5) {
        player = this.map.manager.objectives[a5];
        if (a5 == this.activeObjective) {
          for (var a7 = 0; a7 < this.players.list.length; ++a7) {
            if ((Q = this.players.list[a7]).active && Q.collides(player)) {
              this.players.score(
                Q,
                this.mode && this.mode.objScore ? this.mode.objScore : 10,
              );
            }
          }
        }
      }
    }
    if (this.map.zone) {
      if (!io || this.waitTimers) {
        this.map.zone.animate(a0);
      } else {
        this.zoneTimer -= a0;
        this.map.zone.update(a0 / 1000);
        if (this.zoneTimer <= 0) {
          this.zoneTimer = 1000;
          window.IO.broadcast("game" + this.sid, "zn", this.map.zone.getData());
          for (a7 = 0; a7 < this.players.list.length; ++a7) {
            if (
              (Q = this.players.list[a7]).active &&
              (!this.mode.teamOptions ||
                this.mode.teamOptions[Q.team - 1] != "Infected") &&
              this.map.zone.isOutside(Q) &&
              this.players.changeHealth(Q, null, 10)
            ) {
              this.players.kill(Q, null, {});
            }
          }
        }
      }
    }
    this.projectiles.update(a0 * this.config.deltaMlt);
    if (PARTICLES) {
      PARTICLES.update(
        a0 * this.config.deltaMlt,
        window.spectating ? RENDER.fpsCamera.getWorldPosition() : a2,
      );
    }
    if (RENDER) {
      RENDER.render(a0 * this.config.deltaMlt);
    }
    if (io) {
      for (a5 = 0; a5 < this.players.list.length; ++a5) {
        if (
          (player = this.players.list[a5]).active &&
          player.lastProg != player.interProg
        ) {
          player.lastProg = player.interProg;
          io.send(player.id, "p", (player.interProg || 0).round(3));
          for (var a8 = 0; a8 < this.players.list.length; ++a8) {
            if (this.players.list[a8].specStream == player.sid) {
              io.send(
                this.players.list[a8].id,
                "p",
                (player.interProg || 0).round(3),
              );
            }
          }
        }
      }
      for (a5 = 0; a5 < this.teamScoreUpd.length; ++a5) {
        window.IO.broadcast(
          "game" + this.sid,
          "ts",
          this.teamScoreUpd[a5],
          this.teams[this.teamScoreUpd[a5]],
        );
      }
      if (this.leadersUpdated) {
        this.players.syncLeaders(true);
      }
      this.teamScoreUpd.length = 0;
    }
  };
  this.destroyGame = function () {
    if (this.isDestroyed) {
      console.warn("Destroying game twice");
    } else {
      this.isDestroyed = true;
      if (this.customMapData && this.customMapData.id) {
        dbClient.call(
          81,
          [this.playTime, this.playCount || 1, this.customMapData.id],
          function () {},
        );
      }
      window.IO.broadcast("game" + this.sid, "error", "Host ended game");
      io.clearRoom("game" + this.sid);
      if (this.gameInstance) {
        this.gameInstance.destroy();
      }
      var a0 = games.indexOf(this);
      if (a0 >= 0) {
        games.splice(a0, 1);
      } else {
        console.warn(
          "Games is missing game (which will result in an empty custom game)",
          {
            game: this,
            games: games,
          },
        );
      }
    }
  };
  this.validateAccountName = function (a0) {
    return !this.accountTeams || (!!a0 && this.getAccountTeamIndex(a0) != -1);
  };
  this.getAccountTeamIndex = function (a0) {
    if (!this.accountTeams || !a0) {
      return -1;
    }
    for (var a1 = 0; a1 < this.accountTeams.length; a1++) {
      for (var a2 of this.accountTeams[a1]) {
        if (a2.accountId == a0) {
          return a1;
        }
      }
    }
    return -1;
  };
};
